// Statsig client-side SDK key for A/B testing and feature flags
// This is safe to expose publicly as it's designed for client-side use
// For key regeneration, visit: https://console.statsig.com/3mPNUA7UdeOTHT3NVxfc89/api_keys
export const statsigConfig = {
  clientKey: 'client-BlHZil16zNxWPUxyyVyiqUSkg7ZzGKPrmdFa6m12r6q',
}
